import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import stl from "./MakeModelYearTag.module.css";
var MakeModelYearTag = function MakeModelYearTag(_ref) {
  var title = _ref.title,
    url = _ref.url,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(Link, {
    id: id,
    to: url,
    className: stl.tag
  }, title);
};
export default MakeModelYearTag;